'use client';

import { ProductDetailPageProps } from '@/types/ProductDetailPageProps';
import Button from '@/components/button';
import { pseudoI18n } from '@/i18n/pseudoI18n';

export default function ProductAdditionalInfo(props: ProductDetailPageProps) {
  const { product, setting, theme } = props;

  const { ctaPhoneNumber } = setting?.product || {};

  const { t } = pseudoI18n();

  if (!product) return null;

  return (
    <div className="mt-6">
      <Button
        style="primary-button--inverse"
        className="w-full sm:w-fit flex gap-2 items-center justify-center group flex-wrap"
        url={`tel:${ctaPhoneNumber}`}
        theme={theme}
      >
        <span>{t('Call to order')}</span>
        <strong className="text-h4-mobile font-bold text-secondary group-hover:text-white transition-all duration-500">
          {ctaPhoneNumber}
        </strong>
      </Button>
    </div>
  );
}
